import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";

export const GDPRBanner = () => {
  const { t } = useLanguage();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("gdpr-consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("gdpr-consent", "all");
    setShowBanner(false);
  };

  const acceptEssential = () => {
    localStorage.setItem("gdpr-consent", "essential");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background/95 backdrop-blur-md border-t border-accent/20 p-4 z-50">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-sm text-muted-foreground">
          {t("gdpr.message")}
          <a
            href="/privacy-policy"
            className="text-accent hover:underline ml-1"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("gdpr.privacy")}
          </a>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={acceptEssential}>
            {t("gdpr.essential")}
          </Button>
          <Button size="sm" onClick={acceptAll}>
            {t("gdpr.acceptAll")}
          </Button>
        </div>
      </div>
    </div>
  );
};
